import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Container,
  TicketRow,
  UnreadDot,
  TicketContent,
  TicketDate
} from './ShimmerHelpCenterTicketList.styles';
import { ShimmerHelpCenterTicketListProps } from './ShimmerHelpCenterTicketList.types';

const skeletonProps = {
  baseColor: '#ebebeb',
  highlightColor: '#f5f5f5'
};

const ShimmerTicketRow = () => (
  <TicketRow>
    <UnreadDot>
      <Skeleton circle width={6} height={6} {...skeletonProps} />
    </UnreadDot>
    <TicketContent>
      <Skeleton width={220} height={14} {...skeletonProps} />
      <Skeleton width={140} height={12} {...skeletonProps} />
    </TicketContent>
    <TicketDate>
      <Skeleton width={44} height={14} {...skeletonProps} />
    </TicketDate>
  </TicketRow>
);

export const ShimmerHelpCenterTicketList = ({
  count = 5,
  width,
  height
}: ShimmerHelpCenterTicketListProps) => {
  return (
    <Container $width={width} $height={height}>
      {Array.from({ length: count }).map((_, i) => (
        <ShimmerTicketRow key={i} />
      ))}
    </Container>
  );
};
